const SunSvg = ({
  height = 17,
  width = 17,
  viewBox = '0 0 17 17',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M8.5 2.5V1M8.5 14.5V16M4.31066 4.31066L3.25 3.25M12.796 12.796L13.8567 13.8567M2.5 8.5H1M14.5 8.5H16M12.7964 4.31066L13.857 3.25M4.31103 12.796L3.25037 13.8567M8.5 12.25C6.42893 12.25 4.75 10.5711 4.75 8.5C4.75 6.42893 6.42893 4.75 8.5 4.75C10.5711 4.75 12.25 6.42893 12.25 8.5C12.25 10.5711 10.5711 12.25 8.5 12.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default SunSvg;
